var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmsTracking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88534 5.2371C3.20538 5.86848 2.75 6.89295 2.75 8.5C2.75 8.91421 2.41421 9.25 2 9.25C1.58579 9.25 1.25 8.91421 1.25 8.5C1.25 6.60705 1.79462 5.13152 2.86466 4.1379C3.92465 3.15363 5.38503 2.75 7 2.75H17C18.615 2.75 20.0754 3.15363 21.1353 4.1379C22.2054 5.13152 22.75 6.60705 22.75 8.5V15.5C22.75 17.393 22.2054 18.8685 21.1353 19.8621C20.0754 20.8464 18.615 21.25 17 21.25H7C6.58579 21.25 6.25 20.9142 6.25 20.5C6.25 20.0858 6.58579 19.75 7 19.75H17C18.385 19.75 19.4246 19.4036 20.1147 18.7629C20.7946 18.1315 21.25 17.107 21.25 15.5V8.5C21.25 6.89295 20.7946 5.86848 20.1147 5.2371C19.4246 4.59637 18.385 4.25 17 4.25H7C5.61497 4.25 4.57535 4.59637 3.88534 5.2371Z",
    fill: "#323130"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.586 8.53196C17.8445 8.85561 17.7917 9.32754 17.4681 9.58605L14.3372 12.0868C13.0338 13.1244 10.9563 13.1244 9.65289 12.0868L9.65104 12.0853L6.53105 9.58531C6.2078 9.3263 6.15573 8.85429 6.41474 8.53105C6.67375 8.2078 7.14576 8.15573 7.46901 8.41474L10.588 10.914C11.3446 11.5155 12.6462 11.5154 13.4025 10.9135C13.4027 10.9135 13.4024 10.9136 13.4025 10.9135L16.532 8.41401C16.8556 8.15551 17.3275 8.20832 17.586 8.53196Z",
    fill: "#323130"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 16.5C1.25 16.0858 1.58579 15.75 2 15.75H8C8.41421 15.75 8.75 16.0858 8.75 16.5C8.75 16.9142 8.41421 17.25 8 17.25H2C1.58579 17.25 1.25 16.9142 1.25 16.5Z",
    fill: "#323130"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 12.5C1.25 12.0858 1.58579 11.75 2 11.75H5C5.41421 11.75 5.75 12.0858 5.75 12.5C5.75 12.9142 5.41421 13.25 5 13.25H2C1.58579 13.25 1.25 12.9142 1.25 12.5Z",
    fill: "#323130"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsTracking);
export default __webpack_public_path__ + "static/media/sms-tracking.d907bd7d19387f175888b095793a14c6.svg";
export { ForwardRef as ReactComponent };